<script> 
export default { 
  data() {
    return { 
    };
  },
  components: { 
  }, 
  methods: { 
  },
};
</script>

<template> 
          <div class="banner">
        <img src="@/../public/assets/images/slide3.jpg" class="banner-image" alt="" />
    </div>
</template>
